module.exports = __webpack_public_path__ + "static/img/m_index_03.26b1a260.jpg";